// PointViews tooltip for plain-DOM UI (Potree's own panels, Digitalisering, context menus, ...):
// replaces the browser's NATIVE `title` tooltip with the same kind of tooltip the Vue UI gets from
// Vuetify's v-tooltip (dark grey bubble, white text, ~250 ms open delay, below the element).
//
// One delegated handler on `document` - no per-element wiring - so every element that carries a
// `title` attribute (including HTML built from strings by jQuery/innerHTML code) is covered, now and
// in future. On first hover the text is moved from `title` to `data-pv-title` (that is what stops
// the native tooltip from ever appearing); if a framework later sets `title` again it is simply
// picked up on the next hover. Opt out per element with `data-native-title`.
//
// Vue components should still use v-tooltip (components/pointcloud/tip.vue) - this is the
// safety net for everything that is not Vue.

const OPEN_DELAY_MS = 250;
const SELECTOR = "[title], [data-pv-title]";

let installed = false;
let bubble = null;
let current = null;
let timer = null;

function ensureBubble(){
	if(!bubble){
		bubble = document.createElement("div");
		bubble.className = "pv-title-tooltip";
		bubble.setAttribute("role", "tooltip");
		document.body.appendChild(bubble);
	}
	return bubble;
}

function hide(){
	clearTimeout(timer);
	timer = null;
	current = null;
	if(bubble) bubble.style.display = "none";
}

function show(el, text){
	const b = ensureBubble();
	b.textContent = text;
	b.style.display = "block";
	b.style.left = "-9999px";
	b.style.top = "-9999px";

	const a = el.getBoundingClientRect();
	const r = b.getBoundingClientRect();
	const margin = 8;

	let left = a.left + a.width / 2 - r.width / 2;
	left = Math.max(margin, Math.min(left, window.innerWidth - r.width - margin));

	let top = a.bottom + 6;
	if(top + r.height > window.innerHeight - margin){
		top = a.top - r.height - 6; // no room below: flip above
	}
	top = Math.max(margin, top);

	b.style.left = left + "px";
	b.style.top = top + "px";
}

// "title" -> "data-pv-title"; returns the tooltip text (or null if none)
function takeOver(el){
	const t = el.getAttribute("title");
	if(t !== null){
		el.removeAttribute("title");
		if(t.trim() !== "") el.setAttribute("data-pv-title", t);
	}
	const text = el.getAttribute("data-pv-title");
	return text && text.trim() !== "" ? text : null;
}

export function installTitleTooltips(){
	if(installed || typeof document === "undefined") return;
	installed = true;

	document.addEventListener("mouseover", (e) => {
		const t = e.target;
		const el = t && t.closest ? t.closest(SELECTOR) : null;
		if(!el || el.hasAttribute("data-native-title")){
			if(current) hide();
			return;
		}
		if(el === current) return;
		const text = takeOver(el);
		hide();
		if(!text) return;
		current = el;
		timer = setTimeout(() => { if(current === el && document.body.contains(el)) show(el, text); }, OPEN_DELAY_MS);
	}, true);

	document.addEventListener("mouseout", (e) => {
		if(current && !current.contains(e.relatedTarget)) hide();
	}, true);

	// anything that makes the hovered element's tooltip stale
	document.addEventListener("mousedown", hide, true);
	document.addEventListener("keydown", hide, true);
	window.addEventListener("scroll", hide, true);
	window.addEventListener("blur", hide);
}
